<template>
  <div
    class="bg-background border-background-fg/8 flex flex-grow flex-col overflow-y-auto border-r pb-4 pt-5"
  >
    <div
      class="flex flex-shrink-0 flex-col items-center justify-center px-4"
    >
      <IconBrandLogo class="h-auto w-full" />
      <p
        class="text-primary w-full text-right text-xs font-bold"
        >Group Web Portal</p
      >
    </div>
    <div class="w-full flex-shrink-0 px-4">
      <p
        class="text-background-fg/70 line-clamp-2 w-full text-lg font-medium"
      >
        {{ merchantGroup?.name }}
      </p>
    </div>
    <div
      class="border-background-fg/20 mt-2 flex flex-grow flex-col border-t pt-4"
    >
      <nav
        class="bg-background flex flex-1 flex-col space-y-2 px-2"
        aria-label="Sidebar"
      >
        <template
          v-for="item in navigation"
          :key="item.name"
        >
          <RouterLink
            #default="{
              href: childHref,
              navigate: childNavigate,
              route: { meta: childMeta },
              isExactActive: isChildActive,
            }"
            :to="{ name: item.name }"
            custom
          >
            <div
              :class="[
                'space-y-1 border-l-2',
                isChildActive
                  ? 'border-primary bg-background-fg/3 text-background-fg/87'
                  : 'text-background-fg/70 border-transparent bg-white',
              ]"
            >
              <a
                :href="childHref"
                :class="[
                  isChildActive
                    ? 'bg-primary/10'
                    : 'hover:bg-background-fg/3 hover:text-background-fg/87',
                  'text-background-fg/70 group flex w-full items-center rounded-md px-2 py-2 text-sm font-medium',
                ]"
                @click="childNavigate"
              >
                <Component
                  :is="childMeta.icon"
                  :class="['mr-3 h-6 w-6 flex-shrink-0']"
                  aria-hidden="true"
                  @click="childNavigate"
                />
                {{ childMeta.pageTitle }}
              </a>
            </div>
          </RouterLink>
        </template>
        <div class="flex-1"> </div>

        <template v-if="merchantGroupAdmin?.email">
          <div class="bg-background-fg/20 h-px w-full" />
          <div class="space-y-1">
            <div
              class="text-background-fg/80 flex items-center px-4 py-2 text-sm font-medium"
            >
              {{ merchantGroupAdmin.email }}
            </div>
            <RouterLink
              #default="{ navigate, href }"
              custom
              :to="{
                name: 'changePasswordMerchantGroup',
              }"
            >
              <div class="relative">
                <a
                  class="text-background-fg/50 hover:bg-background-fg/10 hover:text-background-fg/80 block w-full px-4 py-2 text-left text-base font-medium"
                  :href="href"
                  @click="navigate"
                >
                  {{ changePasswordText }}
                </a>
                <template v-if="shouldAlertPassword">
                  <IconHeroiconsSolidExclamationCircle
                    class="text-error ah-4 absolute right-1 top-0 w-4"
                  />
                </template>
              </div>
            </RouterLink>
            <button
              class="text-background-fg/50 hover:bg-background-fg/10 hover:text-background-fg/80 block w-full px-4 py-2 text-left text-base font-medium"
              @click="onClickLogout"
            >
              Log Out
            </button>
          </div>
        </template>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMerchantGroupAdmin } from "@/composables/merchantGroup/useMerchantGroupAdmin"
import { queryClient } from "@/queryClient"
type Navigation = {
  name: string
  children?: {
    name: string
  }[]
}[]

const merchantGroupAdmin = useMerchantGroupAdmin()
const merchantGroup = useMerchantGroup()

const navigation = computed(
  () =>
    [
      {
        name: "homeMerchantGroup",
      },
      {
        name: "merchantGroupUsersIndex",
      },
    ] satisfies Navigation
)

const { setToken } = useMerchantGroupAuth()

const onClickLogout = () => {
  setToken(null)
  queryClient.invalidateQueries()
}

const shouldAlertPassword = computed(
  () => merchantGroupAdmin.value?.hasPassword === false
)
const changePasswordText = computed(() =>
  merchantGroupAdmin.value?.hasPassword
    ? "Change Password"
    : "Set Password"
)
</script>
